import { render, staticRenderFns } from "./PlaceListItem.vue?vue&type=template&id=d6392c52&"
import script from "./PlaceListItem.vue?vue&type=script&lang=ts&"
export * from "./PlaceListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports